import {useState,  useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import { useSessionContext } from '../../../contexts/SessionContext';

export default function ShipmentsFilterStatusList(props) {
    //console.debug("RTS Break ShipmentsFilterStatusList");

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    // This must come after the repoStatus is set because of the find.
    const [status, setStatus] = useState(1);
    const repoStatus = [{value:-1, label:"All"},
                        {value:1, label:"Active"},
                        {value:25, label:"Marked for Pickup"},
                        {value:50, label:"On Pickup Request"},
                        {value:75, label:"Submitted for Pickup"},
                        {value:100, label:"Returned"}];


    useEffect(() => {
        setStatus(props.status!=null?props.status:1);
    }, [props.status]); 


    function valChange(e, val){
        props.setStatusFx(val.value);
        setStatus(val);
    }    


    return(
        <>
            <Autocomplete
                options={repoStatus}
                renderInput={(params) => <TextField {...params} label="Status" margin='slim' size="small" />}
                value={repoStatus.find(v => v.value===status)}
                onChange={valChange}
                getOptionLabel={(repoStatus) => repoStatus.label + ' (' + repoStatus.value + ')'}
                renderOption={(props, repoStatus) => (
                    <Box component="li" {...props} key={repoStatus.value}>
                        {repoStatus.label + ' (' + repoStatus.value + ')'}
                    </Box>
                )}
                disabled={props.disabled?props.disabled:false}
            />
        </>
    );
}

